import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HttpClientModule, HttpClientJsonpModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AutoSuggestComponent } from './comp/auto-suggest/auto-suggest.component';
import { BusyIndicatorViewComponent } from './comp/busy-indicator-view/busy-indicator-view.component';
import { ButtonDropdownComponent } from './comp/button-dropdown/button-dropdown.component';
import { ButtonGroupComponent } from './comp/button-group/button-group.component';
import { CalendarComponent } from './comp/calendar/calendar.component';
import { CalendarPopupComponent } from './comp/calendar-popup/calendar-popup.component';
import { ComingSoonComponent } from './comp/coming-soon/coming-soon.component';
import { DateNavigatorComponent } from './comp/date-navigator/date-navigator.component';
import { DateRangeComponent } from './comp/date-range/date-range.component';
import { DateRangePopupComponent } from './comp/date-range-popup/date-range-popup.component';
import { LoadingComponent } from './comp/loading/loading.component';
import { LoadingResultsComponent } from './comp/loading-results/loading-results.component';
import { MessageToastComponent } from './comp/message-toast/message-toast.component';
import { MobileViewPortPaneComponent } from './comp/mobile-view-port-pane/mobile-view-port-pane.component';
import { NoResultsComponent } from './comp/no-results/no-results.component';
import { ProgressComponent } from './comp/progress/progress.component';
import { RemarksPopupComponent } from './comp/remarks-popup/remarks-popup.component';
import { SelectComponent } from './comp/select/select.component';
import { StarRatingComponent } from './comp/star-rating/star-rating.component';
import { StepperComponent } from './comp/stepper/stepper.component';
import { TextAreaComponent } from './comp/text-area/text-area.component';
import { TextBoxComponent } from './comp/text-box/text-box.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorPipe } from './pipes/errors/error.pipe';
import { InvalidFieldPipe } from './pipes/validator/invalid-field.pipe';
import { FieldErrorComponent } from './comp/field-error/field-error.component';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CalendarHeaderComponent } from './comp/calendar-header/calendar-header.component';
import { ImageSelectionComponent } from './comp/image-selection/image-selection.component';
import { TokenInterceptor } from './interceptors/jwt/token.interceptor';
import { MarkupInterceptor } from './interceptors/jwt/markup.interceptor';
import { PopupComponent } from './comp/popup/popup.component';
import { MessageBoxComponent } from './comp/message-box/message-box.component';
import { RtEditorComponent } from './comp/rt-editor/rt-editor.component';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { NaPipe } from './pipes/na.pipe';
import { NgxPopperModule } from 'ngx-popper';
import { FileUploadComponent } from './comp/file-upload/file-upload.component';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { DurationPipe } from './pipes/duration.pipe';
import { AnimatedBusyIndicatorViewComponent } from './comp/animated-busy-indicator-view/animated-busy-indicator-view.component';
import { TripAdvisorRatingComponent } from './comp/trip-advisor-rating/trip-advisor-rating.component';
import { CurrencyWithLocalePipe } from './pipes/currency-with-locale.pipe';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AutoSuggestComponent,
    AnimatedBusyIndicatorViewComponent,
    BusyIndicatorViewComponent,
    ButtonDropdownComponent,
    ButtonGroupComponent,
    CalendarComponent,
    CalendarPopupComponent,
    ComingSoonComponent,
    DateNavigatorComponent,
    DateRangeComponent,
    DateRangePopupComponent,
    LoadingComponent,
    LoadingResultsComponent,
    MessageToastComponent,
    MobileViewPortPaneComponent,
    NoResultsComponent,
    ProgressComponent,
    RemarksPopupComponent,
    SelectComponent,
    StarRatingComponent,
    StepperComponent,
    TextAreaComponent,
    TextBoxComponent,
    FieldErrorComponent,
    CalendarHeaderComponent,
    ImageSelectionComponent,
    PopupComponent,
    MessageBoxComponent,
    RtEditorComponent,


    ErrorPipe,
    InvalidFieldPipe,
    NaPipe,
    FileUploadComponent,
    ClickOutsideDirective,
    SafeUrlPipe,
    DurationPipe,
    TripAdvisorRatingComponent,
    CurrencyWithLocalePipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    EditorModule,
    NgxPopperModule.forRoot({ placement: 'bottom' }),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    TranslateModule,
    NgxPopperModule,
    AnimatedBusyIndicatorViewComponent,
    AutoSuggestComponent,
    BusyIndicatorViewComponent,
    ButtonDropdownComponent,
    ButtonGroupComponent,
    CalendarComponent,
    CalendarPopupComponent,
    ComingSoonComponent,
    DateNavigatorComponent,
    DateRangeComponent,
    DateRangePopupComponent,
    LoadingComponent,
    LoadingResultsComponent,
    MessageToastComponent,
    MobileViewPortPaneComponent,
    NoResultsComponent,
    ProgressComponent,
    RemarksPopupComponent,
    SelectComponent,
    StarRatingComponent,
    StepperComponent,
    TextAreaComponent,
    TextBoxComponent,
    FieldErrorComponent,
    CalendarHeaderComponent,
    ImageSelectionComponent,
    PopupComponent,
    MessageBoxComponent,
    RtEditorComponent,
    FileUploadComponent,
    TripAdvisorRatingComponent,
    ClickOutsideDirective,

    
    ErrorPipe,
    InvalidFieldPipe,
    NaPipe,
    SafeUrlPipe,
    DurationPipe,
    CurrencyWithLocalePipe
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: MarkupInterceptor,
    //   multi: true
    // },
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }
  ]
})
export class TCatCoreModule { }
